import React, { useEffect } from "react";
import { Routes, Route, useLocation, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import AllRoutes from "./AllRoutes.jsx";
import RoutePage from "./RoutePage.jsx";
import AllStops from "./AllStops.jsx";
import TripPlanner from "./TripPlanner.jsx";
import WidgetBlock from "../components/WidgetBlock.jsx";
import SystemMap from "./SystemMap.jsx";
import { RouteDataProvider } from "../context/RouteDataContext.jsx";
import {
  updateDrupalBreadcrumbs,
  updateDrupalPageTitle,
} from "../services/breadcrumbs.js";

function DrupalPageChrome({ title, breadcrumbs = [], children }) {
  const params = useParams();
  const resolvedTitle =
    typeof title === "function" ? title(params) : title;
  const resolvedBreadcrumbs =
    typeof breadcrumbs === "function" ? breadcrumbs(params) : breadcrumbs;

  useEffect(() => {
    updateDrupalPageTitle(resolvedTitle);
    updateDrupalBreadcrumbs(resolvedBreadcrumbs);
  }, [resolvedTitle, resolvedBreadcrumbs]);

  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

/**
 * App - Switches between AllRoutes and Route based on path
 *
 * @see https://reactjs.org/docs/context.html
 * @see https://react-bootstrap.github.io/
 * @see https://visgl.github.io/react-google-maps/
 * @see https://fontawesome.com/v5/search?q=excla&ic=free&o=r
 */
export default function App() {
  return (
    <Container className="ictapp">
      <ScrollToTop />
      <Routes>
        <Route
          path="/plan-your-trip/routes"
          element={
            <DrupalPageChrome title="Routes" breadcrumbs={[{ label: "Routes" }]}>
              <AllRoutes />
            </DrupalPageChrome>
          }
        />
        <Route
          path="/plan-your-trip/stops"
          element={
            <DrupalPageChrome title="Stops" breadcrumbs={[{ label: "Stops" }]}>
              <AllStops />
            </DrupalPageChrome>
          }
        />
        <Route
          path="/plan-your-trip/stops/:stopId"
          element={
            <DrupalPageChrome
              title={({ stopId }) => `Stop #${stopId}`}
              breadcrumbs={({ stopId }) => [
                { label: "Stops", href: "/plan-your-trip/stops" },
                { label: `#${stopId}` },
              ]}
            >
              <AllStops />
            </DrupalPageChrome>
          }
        />
        <Route
          path="/plan-your-trip/routes/:routeId"
          element={
            <DrupalPageChrome
              title={({ routeId }) => `Route ${routeId} Schedule`}
              breadcrumbs={({ routeId }) => [
                { label: "Routes", href: "/plan-your-trip/routes" },
                { label: `Route ${routeId}` },
              ]}
            >
              <RouteDataProvider>
                <RoutePage />
              </RouteDataProvider>
            </DrupalPageChrome>
          }
        />
        <Route
          path="/plan-your-trip/trip-planner"
          element={
            <DrupalPageChrome
              title="Trip Planner"
              breadcrumbs={[{ label: "Trip Planner" }]}
            >
              <TripPlanner />
            </DrupalPageChrome>
          }
        />
        <Route
          path="/plan-your-trip/system-map"
          element={
            <DrupalPageChrome
              title="System Map"
              breadcrumbs={[{ label: "System Map" }]}
            >
              <SystemMap />
            </DrupalPageChrome>
          }
        />
        <Route path="/plan-your-trip/widget" element={<WidgetBlock />} />
      </Routes>
    </Container>
  );
}
